import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { environment } from '@env/environment';
import { AuthStateModel } from '../store/auth.state';
import { inProviderSpace } from '../models/session-role';

/**
 * Guard for the intro/welcome route (path: ''). If the user already has a
 * (restored) authenticated session, send them to their role home instead of
 * showing the welcome/intro page; otherwise allow the intro to render.
 *
 * Role home mirrors AppComponent.getMenuPages: appMode client -> /consumer,
 * server -> /provider, all -> owner/provider/consumer (`inProviderSpace`: any tenant member).
 */
@Injectable({ providedIn: 'root' })
export class AuthedHomeRedirectGuard {
  constructor(private store: Store, private router: Router) {}

  canActivate(): boolean | UrlTree {
    const authState = this.store.selectSnapshot<AuthStateModel>(state => state.authState);
    const user = authState?.user;
    if (!authState?.isAuthenticated || !user) {
      return true; // not signed in -> show the intro/welcome page
    }

    let path = '/consumer';
    if (environment.appMode === 'client') {
      path = '/consumer';
    } else if (environment.appMode === 'server') {
      path = '/provider';
    } else {
      // 'all'
      if (user.isPlatformOwner) {
        path = '/owner';
      } else if (inProviderSpace(user)) {
        // every tenant member, staff too (the owner's rule, 28 Sep 2026)
        path = '/provider';
      } else {
        path = '/consumer';
      }
    }
    return this.router.parseUrl(path);
  }
}
